var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gjxx-view-static",attrs:{"id":"app"}},[_c('PublicResourceHeader',{on:{"register":_vm.onRegister}}),_c('PublicResourceTemplace',{on:{"register":_vm.onRegister}},[_c('gjxxList',{attrs:{"listObj":_vm.listObj}})],1),(!_vm.isHeadlessBrowser)?_c('FixedSuspension',{on:{"register":_vm.onRegister}}):_vm._e(),_c('GjxxFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }